module.exports = __webpack_public_path__ + "static/media/blue-sky-with-clouds-background.f50e56d5.webp";